import imageCompression from 'browser-image-compression'

async function compressImageFile (file, maxSizeKB, maxWidthOrHeight) {
  const options = {
    maxSizeMB: maxSizeKB / 1000,
    maxWidthOrHeight: maxWidthOrHeight,
  };
  const compressedFile = await imageCompression(file, options);
  return compressedFile;
}

async function downloadCsvFile (data, fileName) {
  const link = await document.createElement('a');
  link.href = await window.URL.createObjectURL(new Blob([data]));
  await link.setAttribute('download', fileName);
  await document.body.appendChild(link);
  await link.click();
  await document.body.removeChild(link);
}

export {
  compressImageFile,
  downloadCsvFile,
};
